// 项目类型字典
export const projectTypeDic = [
  { label: "防水", value: "WATERPROOF" },
  { label: "回填", value: "BACKFILL" },
  { label: "吊顶", value: "HANG_CEILING" },
];

// 价盘状态字典
export const priceBookStatusDic = [
  { label: "草稿", value: "DRAFT" },
  { label: "启用", value: "ENABLE" },
  { label: "停用", value: "DISABLE" },
];

// 价盘类型字典（匹配优先级：特价 > 活动 > 标准 > 基价）
export const priceBookTypeDic = [
  { label: "基价", value: "BASE" },
  { label: "标准", value: "STANDARD" },
  { label: "活动", value: "ACTIVITY" },
  { label: "特价", value: "SPECIAL" },
];

// 价盘主表标准价格计价项
export const pricingItemDic = [
  // 基础面积是各项目类型的公共计价项，其余计价项按项目类型隔离。
  { label: "基础面积", value: "BASE_AREA", projectTypes: ["WATERPROOF", "BACKFILL", "HANG_CEILING"] },
  { label: "二排", value: "SECOND_DRAIN", projectTypes: ["BACKFILL"] },
  { label: "模具", value: "MOLD", projectTypes: ["BACKFILL"] },
  { label: "丙纶施工面积", value: "POLYPROPYLENE_AREA", projectTypes: ["WATERPROOF"] },
  { label: "步梯楼层数", value: "STAIR_FLOOR", projectTypes: ["BACKFILL"] },
  { label: "二次上门增加施工面积", value: "SECOND_VISIT_AREA", projectTypes: ["WATERPROOF"] },
];

// 价目表（价盘）列表表格配置
export const priceBookTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: true,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: true,
  menuWidth: 360,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuType: "text",
  column: [
    {
      label: "价目表名称",
      prop: "name",
      search: true,
      searchPlaceholder: "请输入价目表名称",
      type: "input",
      minWidth: 160,
    },
    {
      label: "项目类型",
      prop: "projectType",
      type: "select",
      dicData: projectTypeDic,
      search: true,
      width: 100,
    },
    {
      label: "价盘编号",
      prop: "code",
      minWidth: 120,
    },
    {
      label: "价盘类型",
      prop: "priceBookType",
      type: "select",
      dicData: priceBookTypeDic,
      search: true,
      width: 90,
    },
    {
      label: "生效调价",
      prop: "activeAdjustTaskCount",
      slot: true,
      width: 110,
    },
    {
      label: "阈值",
      prop: "threshold",
      slot: true,
      width: 100,
    },
    {
      label: "生效开始",
      prop: "effectiveStartTime",
      slot: true,
      type: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 150,
    },
    {
      label: "生效结束",
      prop: "effectiveEndTime",
      slot: true,
      type: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 150,
    },
    {
      label: "生效状态",
      prop: "effectiveStatus",
      slot: true,
      width: 100,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      dicData: priceBookStatusDic,
      search: true,
      slot: true,
      width: 90,
    },
    {
      label: "审批状态",
      prop: "approvalStatus",
      slot: true,
      width: 150,
    },
    {
      label: "创建时间",
      prop: "createTime",
      slot: true,
      type: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 150,
    },
  ],
};
